import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { config } from '../../constants/config_constants';
import SnapchatLogin from './SnapchatLogin';
import BSAuthLogin from './BSAuthLogin';
import * as session_handlers from '../../actions/session_handler';
import './LoginContainer.css';


const COOKIES_REMINDER_LABEL_FIRST = 
    'We use cookies to help operate our site. For more on how we use cookies, go to our ';
const COOKIES_REMINDER_LABEL_SECOND = '. By logging in, you are giving us consent to use cookies.';
const COOKIES_PAGE = 'Cookies Page';
class LoginContainer extends Component {
    render() {
        const { session } = this.props;
        return (
            <div className="login-container">
                <div className="left-col">
                    <div className="login-title">
                        <p>Have a Bitmoji?</p>
                    </div>
                    <SnapchatLogin isUserLoggingIn={session.isLoggingIn}
                                   isLoginError={session.isLoginError} />
                    <BSAuthLogin isUserLoggingIn={session.isLoggingIn} />
                    <div className="forgot-password">
                        <a href={config.endpoints.FORGOT_PASSWORD_ENDPOINT}>
                            Forgot Password
                        </a>
                    </div>
                </div>
                <div className="right-col">
                    <div className="graphic-login" />
                    <div className="cookies-dialog">
                        <span>{COOKIES_REMINDER_LABEL_FIRST}</span>
                        <a href={config.bitmoji_cookies_info_url}>{COOKIES_PAGE}</a>
                        <span>{COOKIES_REMINDER_LABEL_SECOND}</span>
                    </div>
                </div>
            </div>
        );
    }
}

LoginContainer.propTypes = {
    session: PropTypes.object.isRequired
};

export default connect(state => ({
    session: state.sessionReducer
}), session_handlers)(LoginContainer);



// WEBPACK FOOTER //
// ./src/components/login_view/LoginContainer.js